// extracted by mini-css-extract-plugin
export default {"termsWrap":"oHyAOJ7WjsPM7SlX0ah3","terms":"lbhgVfHP7JgeatxnK_r7","login":"cBme6XqVrqLD0PAk1bz4","header":"ETivBHCsCcNjnCdy6bEL"};